import importerActions from 'src/modules/shared/importer/importerActions';
import selectors from 'src/modules/packagingCertification/importer/packagingCertificationImporterSelectors';
import PackagingCertificationService from 'src/modules/packagingCertification/packagingCertificationService';
import fields from 'src/modules/packagingCertification/importer/packagingCertificationImporterFields';
import { i18n } from 'src/i18n';

const packagingCertificationImporterActions = importerActions(
  'PACKAGINGCERTIFICATION_IMPORTER',
  selectors,
  PackagingCertificationService.import,
  fields,
  i18n('entities.packagingCertification.importer.fileName'),
);

export default packagingCertificationImporterActions;